import * as React from 'react';
import { Box, BoxProps, Color, GridDisplay } from '@gousto-internal/citrus-react';

type FullWidthGridProps = {
  children: React.ReactNode;
} & Omit<BoxProps, 'children' | 'display' | 'gridTemplateRows' | 'gridTemplateColumns'>;

export enum FullWidthGridAreas {
  Left = 'left',
  Right = 'right',
  Top = 'top',
  Bottom = 'bottom',
}

export function FullWidthGrid(props: FullWidthGridProps) {
  const { children, bg = Color.White, ...boxProps } = props;

  return (
    <Box
      display={GridDisplay.Grid}
      gridTemplateColumns={['1fr', null, '1fr 1fr']}
      gridTemplateRows={['1fr 1fr', null, '1fr']}
      gridTemplateAreas={[
        `
          '${FullWidthGridAreas.Top}'
          '${FullWidthGridAreas.Bottom}'
        `,
        null,
        `'${FullWidthGridAreas.Left} ${FullWidthGridAreas.Right}'`,
      ]}
      bg={bg}
      {...boxProps}
    >
      {children}
    </Box>
  );
}
